export default {"src":"//prod.smassets.net/assets/smweb/_next/static/media/solution.1f0c748f.svg","height":65,"width":64,"blurWidth":0,"blurHeight":0};